<template>
    <div class="pop_up_layer" style="display: block" @click="fnEvent"></div>
    <div class="pop_up _iframe" :class="{ mobile: state.isMobile }" style="display: block">
        <button class="close_btn icon_wrap" @click="fnEvent">
            <img src="img/close.png" alt="닫기" />
        </button>
        <iframe v-show="!state.isLoading" :src="props.url" @load="state.isLoading = false"></iframe>
        <Spinner v-if="state.isLoading"></Spinner>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, onUnmounted, Spinner, CommonUtils } from "@/BaseComponent";

    export default {
        props: {
            url: {
                type: String,
                default: "",
            },
        },
        components: { Spinner },
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                isLoading: true as boolean,
                isMobile: false as boolean,
            });

            onMounted(() => {
                state.isMobile = CommonUtils.checkIsMobile(700);
                window.addEventListener("resize", () => {
                    state.isMobile = CommonUtils.checkIsMobile(700);
                });
                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            const fnEvent = () => {
                emit("close");
            };
            return { state, fnEvent, props };
        },
    };
</script>

<style scoped>
    .pop_up._iframe {
        max-width: 1280px;
        height: calc(100vh - 100px);
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 15px;
    }
    .pop_up._iframe.mobile {
        width: 100%;
        height: 100%;
        border-radius: unset;
        padding: 0;
    }

    ._iframe iframe {
        width: 100%;
        height: 100%;
    }
</style>
